import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useLoginApi } from './LoginApi';

export const messages = defineMessages({
  headline: { id: 'ForgotPasswordModal.headline', defaultMessage: 'Passwort vergessen?' },
  generalError: {
    id: 'ForgotPasswordModal.request.generalError',
    defaultMessage:
      'Wir konnten Ihre Anfrage leider nicht bearbeiten. Versuchen Sie es später erneut.',
  },
});

export const usePasswordForget = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);
  const { formatMessage, locale } = useIntl();
  const loginApi = useLoginApi();

  const passwordForget = async (emailAddress: string): Promise<boolean> => {
    if (loginApi) {
      try {
        setError(undefined);
        setLoading(true);
        const response = await loginApi.forgotPasswordRequestEmail({
          ecLocale: locale,
          forgotPasswordRequestEmailRequestPayload: { emailAddress },
        });
        if (!response.success) {
          setError(response.message);
        }
        return true;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (e) {
        setError(formatMessage(messages.generalError));
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 250);
      }
    }
    return false;
  };

  return {
    error,
    loading,
    passwordForget,
  };
};
